import { Trophy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@v2/components/ui/card";
import { EmptyState } from "../../components/state";
import { RankMedal } from "../../components/primitives";
import { resolveEaPlayerName, type EaLinkRosterRow } from "../../lib/ea-name";

export function TopMembersCard({
  title,
  rows,
  metric,
  rosterLookup,
}: {
  title: string;
  rows: Array<{ ea_persona: string; ea_name: string | null; data: any }>;
  metric: "goals" | "assists" | "ratingAve";
  rosterLookup?: Map<string, EaLinkRosterRow>;
}) {
  const { t } = useTranslation("common");
  const fmt = (v: any) => (metric === "ratingAve" ? Number(v || 0).toFixed(2) : v || 0);
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-1.5">
        {rows.length === 0 && <EmptyState text={t("common.noData")} />}
        {rows.map((row, idx) => {
          const fallback = row.ea_name || row.ea_persona;
          const resolved = rosterLookup
            ? resolveEaPlayerName({ name: row.ea_persona, proName: row.ea_name }, rosterLookup)
            : { displayName: fallback, linked: false };
          return (
            <div key={row.ea_persona} className="flex items-center gap-2 text-sm">
              <RankMedal rank={idx + 1} />
              <span className="flex-1 truncate font-medium">{resolved.displayName}</span>
              <span className="font-mono tabular-nums font-bold">{fmt(row.data?.[metric])}</span>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
